import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";
export default function Tracks(_ref) {
  let {
    tracks = []
  } = _ref;
  return tracks.map(track => {
    return createElement("track", _extends({
      key: track.src
    }, track));
  });
}
//# sourceMappingURL=tracks.js.map